module.exports = __webpack_public_path__ + "media/control_acceso/euro_ansi-b3d023b7.webp";